
import styles from "./Battery.module.scss";
import React, {
  useState,
  useEffect,
  useRef,
  Component,
  useCallback,
} from "react";
import cn from "classnames";
import Master from "screen/Master";
import EnergyComponent from "components/battery/EnergyComponent";
import SwappingComponent from "components/battery/SwappingComponent";
import ErrorsComponent from "components/battery/ErrorsComponent";
import RevenueComponent from "components/battery/RevenueComponent";
import LocalStorageService from "services/tokenlocalstorage.service";
import ChargedDischargedComponent from "components/battery/ChargedDischargedComponent";
import StateTransitionComponent from "components/battery/StateTransitionComponent";
import Button from "@material-ui/core/Button";
import { getRequest } from "services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";

export default function BatteryAnalytics(props) {
  const [droppedFilter, setDroppedFilter] = useState(false);
  const [selectTime, setSelectTime] = useState("HOUR_24");
  const [selectTimeValue, setSelectTimeValue] = useState("HOUR_24");
  const [navigation, setNavigation] = useState(false);
  const [open, setOpen] = React.useState(false);
  const filterInitialValue = {
    startDate: parseInt(Date.now() / 1000) - 86400,
    endDate: parseInt(Date.now() / 1000),
    siteId: "",
    chargerId: "",
    state: "",
    city: "",
    zoneId: "",
    time: "HOUR_24",
  };

  const batteryId = props.id;
  const batterySerial = props.batterySerial;

  const [filter, setFilter] = useState(filterInitialValue);
  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [swappedEnergyData, setSwappedEnergyData] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [swapDetails, setSwapDetails] = useState([]);
  const [revenueDetail, setRevenueDetail] = useState([]);
  const [chargeDischargeData, setChargeDischargeData] = useState([]);
  const [stateTransition, setStateTransition] = useState([]);
  const [userRole, setUserRole] = useState("");

  const refOpen = useRef(open);
  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);

  const handleClick = (btnType) => {
    if (open) {
      if (btnType == "reset") {
        filter.siteId = filterInitialValue.siteId;
        filter.chargerId = filterInitialValue.chargerId;
        filter.time = filterInitialValue.time;
        setFilter(filterInitialValue);
        getSwappedEnergyData();
        getErrorData();
        getSwapDetails();
        getRevenueDetails();
        getChargeDischargeData();
        getStateTransitionData();
        setSelectTimeValue("HOUR_24");
        window.location.reload();
      } else {
        getSwappedEnergyData(
          batteryId,
          filter.startDate,
          filter.endDate,
          filter
        );
        getErrorData(batteryId, filter.startDate, filter.endDate, filter);
        getSwapDetails(batteryId, filter.startDate, filter.endDate, filter);
        getRevenueDetails(batteryId, filter.startDate, filter.endDate, filter);
        getChargeDischargeData(
          batteryId,
          filter.startDate,
          filter.endDate,
          filter
        );
        getStateTransitionData(
          batteryId,
          filter.startDate,
          filter.endDate,
          filter
        );
        setSelectTimeValue(selectTime);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const getChargers = useCallback(async (siteId) => {
    await getRequestInAssets(
      `bss/swappingStation/getAllSwappingStationsBySite?siteId=${siteId}`
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSites = useCallback(async () => {
    await getRequestInAssets("bss/site/siteList")
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getSites();
  }, []);

  const getChargeDischargeData = useCallback(
    async (id, startDate, endDate, filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (filter?.chargerId === undefined || filter?.chargerId === ""
          ? ""
          : "&chargerId=" + filter.chargerId) +
        (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
          ? ""
          : "&timeFilterEnum=" + filter.timeFilterEnum) +
        (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);
      await getRequest(
        `bss/getBatteryChargeDischarge?batteryId=${id}&startDate=${startDate}&endDate=${endDate}` +
          query
      ).then((res) => {
        if (res && res?.data) {
          setChargeDischargeData(
            res?.data?.map((a) => {
              a = { ...a, energyCharged: a.charged, energySold: a.discharged };
              return a;
            })
          );
        }
      });
    },
    []
  );

  const getSwappedEnergyData = useCallback(
    async (id, startDate, endDate, filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (filter?.chargerId === undefined || filter?.chargerId === ""
          ? ""
          : "&chargerId=" + filter.chargerId) +
        (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
          ? ""
          : "&timeFilterEnum=" + filter.timeFilterEnum) +
        (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);
      await getRequest(
        `bss/getBatteryEnergyDetails?batteryId=${id}&startDate=${startDate}&endDate=${endDate}` +
          query
      ).then((res) => {
        if (res && res?.data) {
          setSwappedEnergyData(res?.data);
        }
      });
    },
    []
  );

  const getStateTransitionData = useCallback(
    async (id, startTime, endTime, filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (filter?.swapStationId === undefined || filter?.swapStationId === ""
          ? ""
          : "&chargerId=" + filter.swapStationId) +
        (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
          ? ""
          : "&timeFilterEnum=" + filter.timeFilterEnum) +
        (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);
      await getRequest(
        `bss/getBatteryStateTransition?batteryId=${id}&startDate=${startTime}&endDate=${endTime}` +
          query
      ).then((res) => {
        if (res && res?.data) {
          setStateTransition(res?.data);
        }
      });
    },
    []
  );

  const getErrorData = useCallback(
    async (id, startDate, endDate, filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (filter?.chargerId === undefined || filter?.chargerId === ""
          ? ""
          : "&chargerId=" + filter.chargerId) +
        (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
          ? ""
          : "&timeFilterEnum=" + filter.timeFilterEnum) +
        (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);
      await getRequest(
        `bss/getBatteryErrorDetails?batteryId=${id}&startDate=${startDate}&endDate=${endDate}` +
          query
      ).then((res) => {
        if (res && res?.data) {
          setErrorData(res.data);
        }
      });
    },
    [errorData]
  );

  const getSwapDetails = useCallback(async (id, startDate, endDate, filter) => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      (filter?.siteId === undefined || filter?.siteId === ""
        ? ""
        : "&siteId=" + filter.siteId) +
      (filter?.chargerId === undefined || filter?.chargerId === ""
        ? ""
        : "&chargerId=" + filter.chargerId) +
      (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
        ? ""
        : "&timeFilterEnum=" + filter.timeFilterEnum) +
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);
    await getRequest(
      `bss/getBatterySwapsDetails?batteryId=${id}&startDate=${startDate}&endDate=${endDate}` +
        query
    ).then((res) => {
      if (res && res?.data) {
        setSwapDetails(res?.data);
      }
    });
  }, []);

  const getRevenueDetails = useCallback(async (id, startDate, endDate) => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      (filter?.siteId === undefined || filter?.siteId === ""
        ? ""
        : "&siteId=" + filter.siteId) +
      (filter?.chargerId === undefined || filter?.chargerId === ""
        ? ""
        : "&chargerId=" + filter.chargerId) +
      (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
        ? ""
        : "&timeFilterEnum=" + filter.timeFilterEnum) +
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);
    await getRequest(
      `bss/getBatteryRevenueDetails?batteryId=${id}&startDate=${startDate}&endDate=${endDate}` +
        query
    ).then((res) => {
      if (res && res?.data) {
        setRevenueDetail(res?.data);
      }
    });
  });

  useEffect(() => {
    getSwappedEnergyData(batteryId, filter.startDate, filter.endDate);
    getErrorData(batteryId, filter.startDate, filter.endDate);
    getChargeDischargeData(batteryId, filter.startDate, filter.endDate);
    getSwapDetails(batteryId, filter.startDate, filter.endDate);
    getRevenueDetails(batteryId, filter.startDate, filter.endDate);
    getStateTransitionData(batteryId, filter.startDate, filter.endDate);
  }, []);

  setTimeout(() => {
    if (navigation === false) {
      setNavigation(null);
    }
  }, 500);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });

    if (event.target.name === "time") {
      setSelectTime(event.target.value);

      if (value === "HOUR_12") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 43200,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_12");
      }
      if (value === "HOUR_24") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
      if (value === "WEEK") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 604800,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK");
      }
      if (value === "WEEK_2") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 1209600,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK_2");
      }
      if (value === "MONTH") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 2628000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH");
      }
      if (value === "MONTH_3") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 7884000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH_3");
      }
      if (value === null) {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
    }

    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, chargerId: "" });
      getChargers(event.target.value);
    }
    if (event.target.name == "chargerId") {
      setFilter({ ...filter, [name]: value });
    }
  };

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      filter.state = headerFilterObj.state;
      filter.city = headerFilterObj.city;
      filter.zoneId = headerFilterObj.zoneId;
    }
    setUserRole(LocalStorageService.get("user-role"));
  }, []);

  // const handleClick = () => {

  //   if (open) {
  //     setSelectTimeValue(selectTime);
  //     getSwappedEnergyData(batteryId, filter.startDate, filter.endDate);
  //     getErrorData(batteryId, filter.startDate, filter.endDate);
  //     getSwapDetails(batteryId, filter.startDate, filter.endDate);
  //     getRevenueDetails(batteryId, filter.startDate, filter.endDate)
  //     getChargeDischargeData(batteryId, filter.startDate, filter.endDate)
  //     getStateTransitionData(batteryId, filter.startDate, filter.endDate)
  //     setOpen(false);
  //   } else {
  //     setOpen(true);
  //   }
  // };

  return (
    <>
      <div
        ref={wrapperRef}
        style={{ cursor: "pointer" }}
        className={cn(styles.block1, styles.block1_layout)}
      >
        <div className={cn(styles.block2, styles.block2_layout)}>
          <div className={cn(styles.block2_item)}>
            <div className={cn(styles.block3, styles.block3_layout)}>
              <div
                style={{
                  "--src": `url(${require("assets/filterblack.png").default})`,
                }}
                className={cn(styles.image1, styles.image1_layout)}
              />
            </div>
          </div>
          <div className={cn(styles.block2_spacer)} />
          <div className={cn(styles.text_body, styles.text_body_layout)}>
            {"Filters"}
          </div>
          <div>
            {open && (
              <div id="filter" open={open} ref={wrapperRefInside}>
                <div
                  className={cn(
                    styles.status2_block,
                    styles.status2_block_layout
                  )}
                >
                  <div>
                    <select
                      style={{ width: "80%", height: "35px" }}
                      name="time"
                      id="time"
                      onChange={handleChange}
                      value={filter.time}
                    >
                      <option value="" disabled selected>
                        Select Time Period
                      </option>
                      <option value="HOUR_24" selected>
                        Last 24 hours
                      </option>
                      <option value="HOUR_12">Last 12 hours</option>
                      <option value="WEEK">Last 1 week</option>
                      <option value="WEEK_2">Last 2 weeks</option>
                      <option value="MONTH">Last 1 month</option>
                      <option value="MONTH_3">Last 3 months</option>
                    </select>
                  </div>

                  {/* <div>
                    <select
                      style={{ width: "80%", height: "35px" }}
                      name="siteId"
                      id="siteId"
                      onChange={handleChange}
                      value={filter.siteId}
                    >
                      <option value="-1" selected>
                         Select Site
                      </option>
                      {sitesList.map((obj) => {
                        return <option value={obj.id}>{obj.name}</option>;
                      })}
                    </select>
                  </div>

                  <div>
                    <select
                      style={{ width: "80%", height: "35px" }}
                      name="chargerId"
                      id="chargerId"
                      onChange={handleChange}
                      value={filter.chargerId}
                    >
                      <option value="" disabled selected>
                      Select Swap Station
                      </option>
                      {chargerList.map((obj) => {
                        return <option value={obj.id}>{obj.name}</option>;
                      })}
                    </select>
                  </div> */}

                  <div>
                    <Button
                      style={{
                        background: "#E3324C",
                        color: "white",
                        margin: "15px 0px 6px 35px",
                        width: "85px",
                        height: "28px",
                      }}
                      onClick={() => {
                        handleClick("reset");
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      style={{
                        background: "#23297A",
                        color: "white",
                        margin: "15px 0px 6px 20px",
                        width: "85px",
                        height: "28px",
                      }}
                      onClick={() => {
                        handleClick("apply");
                      }}
                    >
                      Apply
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={cn(styles.flex4, styles.flex4_layout)}>
        <div className={cn(styles.flex4_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights_box,
                  styles.highlights_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>{"Energy"}</pre>
              </h5>
              <div>
                <EnergyComponent
                  data={swappedEnergyData}
                  selectValue={selectTimeValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div className={cn(styles.flex4_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>{"Errors"}</pre>
              </h5>
              <div>
                <ErrorsComponent
                  data={errorData}
                  selectValue={selectTimeValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div className={cn(styles.flex4_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>
                  {"State Transition"}
                </pre>
              </h5>
              <div>
                <StateTransitionComponent
                  data={[stateTransition]}
                  selectValue={selectTimeValue}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={cn(styles.flex5, styles.flex5_layout)}>
        <div className={cn(styles.flex5_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>{"Swapping"}</pre>
              </h5>
              <div>
                <SwappingComponent
                  data={swapDetails}
                  selectValue={selectTimeValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex5_spacer)} />
        <div className={cn(styles.flex5_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>
                  {"Charged Discharged (kWh)"}
                </pre>
              </h5>
              <div>
                <ChargedDischargedComponent
                  data={chargeDischargeData}
                  selectValue={selectTimeValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex5_spacer)} />
        <div className={cn(styles.flex5_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>{"Revenue (₹)"}</pre>
              </h5>
              <div>
                <RevenueComponent
                  data={revenueDetail}
                  selectValue={selectTimeValue}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function BatteryAnalytic(props) {
  return (
    <>
      <Master opts={props} screen={BatteryAnalytics} showStatus={true} />
    </>
  );
}

BatteryAnalytic.inStorybook = true;

// return (

//   <>
//   <div
//   ref={wrapperRef}
//   style={{ cursor: "pointer" }}
//   className={cn(styles.block1, styles.block1_layout)}>
//   <div className={cn(styles.block2, styles.block2_layout)}>
//   <div className={cn(styles.block2_item)}>
//   <div className={cn(styles.block3, styles.block3_layout)}>
//   <div
//   style={{
//   '--src': `url(${
//   require('assets/filterblack.png')
//   .default
//   })`
//   }}
//   className={cn(styles.image1, styles.image1_layout)}
//   />
//   </div>
//   </div>
//   <div className={cn(styles.block2_spacer)} />
//   <div className={cn(styles.text_body, styles.text_body_layout)}>
//   {'Filters'}
//   </div>
//   <div>
//   {open && (
//   <div id="filter" open={open} ref={wrapperRefInside}>
//   <div
//   className={cn(
//   styles.status2_block,
//   styles.status2_block_layout
//   )}
//   >
//   <div>
//   <select
//   style={{ width: "80%", height: "35px" }}
//   name="time"
//   id="time"
//   onChange={handleChange}
//   value={filter.time}
//   >
//   {/* <option value="-1" selected>
//   Time Period
//   </option> */}
//   <option value="HOUR_24" selected>
//   Last 24 hours
//   </option>
//   <option value="HOUR_12">Last 12 hours</option>
//   <option value="WEEK">Last 1 week</option>
//   <option value="WEEK_2">Last 2 weeks</option>
//   <option value="MONTH">Last 1 month</option>
//   <option value="MONTH_3">Last 3 months</option>
//   </select>
//   </div>

//   <div>
//   <select
//   style={{ width: "80%", height: "35px" }}
//   name="siteId"
//   id="siteId"
//   onChange={handleChange}
//   value={filter.siteId}
//   >
//   <option value="-1" selected>
//   Site
//   </option>
//   {sitesList.map((obj) => {
//   return <option value={obj.id}>{obj.name}</option>;
//   })}
//   </select>
//   </div>

//   <div>
//   <select
//   style={{ width: "80%", height: "35px" }}
//   name="chargerId"
//   id="chargerId"
//   onChange={handleChange}
//   value={filter.chargerId}
//   >
//   <option value="" disabled selected>
//   Charger
//   </option>
//   {chargerList.map((obj) => {
//   return <option value={obj.id}>{obj.name}</option>;
//   })}
//   </select>
//   </div>

//   <div>
//   <Button
//   style={{
//   background: "#E3324C",
//   color: "white",
//   margin: "15px 0px 6px 35px",
//   width: "85px",
//   height: "28px",
//   }}
//   onClick={() => {handleClick('reset')}}
//   >
//   Reset
//   </Button>
//   <Button
//   style={{
//   background: "#23297A",
//   color: "white",
//   margin: "15px 0px 6px 20px",
//   width: "85px",
//   height: "28px",
//   }}
//   onClick={() => {handleClick('apply')}}
//   >
//   Apply
//   </Button>
//   </div>
//   </div>
//   </div>
//   )}
//   </div>
//   </div>
//   </div>

//   <div className={cn(styles.flex4, styles.flex4_layout)}>
//   <div className={cn(styles.flex4_item)}>
//   <div className={cn(styles.block6, styles.block6_layout)}>
//   <div className={cn(styles.block7, styles.block7_layout)}>
//   <h5
//   className={cn(
//   styles.highlights_box,
//   styles.highlights_box_layout
//   )}>
//   <pre className={cn(styles.highlights)}>
//   {'Energy'}
//   </pre>
//   </h5>
//   <div>
//   <EnergyComponent data={swappedEnergyData} selectValue={selectTimeValue}/>
//   </div>
//   </div>
//   </div>
//   </div>
//   <div className={cn(styles.flex4_spacer)} />
//   <div className={cn(styles.flex4_item)}>
//   <div className={cn(styles.block6, styles.block6_layout)}>
//   <div className={cn(styles.block7, styles.block7_layout)}>
//   <h5
//   className={cn(
//   styles.highlights1_box,
//   styles.highlights1_box_layout
//   )}>
//   <pre className={cn(styles.highlights)}>
//   {'Errors'}
//   </pre>
//   </h5>
//   <div>
//   <ErrorsComponent data ={errorData} selectValue={selectTimeValue}/>
//   </div>
//   </div>
//   </div>
//   </div>
//   <div className={cn(styles.flex4_spacer)} />
//   <div className={cn(styles.flex4_item)}>
//   <div className={cn(styles.block6, styles.block6_layout)}>
//   <div className={cn(styles.block7, styles.block7_layout)}>
//   <h5
//   className={cn(
//   styles.highlights1_box,
//   styles.highlights1_box_layout
//   )}>
//   <pre className={cn(styles.highlights)}>
//   {'State Transition'}
//   </pre>
//   </h5>
//   <div>

//   <StateTransitionComponent data ={[stateTransition]} selectValue={selectTimeValue}/>
//   </div>
//   </div>
//   </div>
//   </div>
//   </div>

//   <div className={cn(styles.flex5, styles.flex5_layout)}>
//   <div className={cn(styles.flex5_item)}>
//   <div className={cn(styles.block6, styles.block6_layout)}>
//   <div className={cn(styles.block7, styles.block7_layout)}>
//   <h5
//   className={cn(
//   styles.highlights1_box,
//   styles.highlights1_box_layout
//   )}>
//   <pre className={cn(styles.highlights)}>
//   {'Swapping'}
//   </pre>
//   </h5>
//   <div>
//   <SwappingComponent data = {swapDetails} selectValue={selectTimeValue}/>
//   </div>
//   </div>
//   </div>
//   </div>
//   <div className={cn(styles.flex5_spacer)} />
//   <div className={cn(styles.flex5_item)}>
//   <div className={cn(styles.block6, styles.block6_layout)}>
//   <div className={cn(styles.block7, styles.block7_layout)}>
//   <h5
//   className={cn(
//   styles.highlights1_box,
//   styles.highlights1_box_layout
//   )}>
//   <pre className={cn(styles.highlights)}>
//   {'Charged Discharged'}
//   </pre>
//   </h5>
//   <div>

//   <ChargedDischargedComponent data={chargeDischargeData} selectValue={selectTimeValue}/>
//   </div>
//   </div>
//   </div>
//   </div>
//   <div className={cn(styles.flex5_spacer)} />
//   <div className={cn(styles.flex5_item)}>
//   <div className={cn(styles.block6, styles.block6_layout)}>
//   <div className={cn(styles.block7, styles.block7_layout)}>
//   <h5
//   className={cn(
//   styles.highlights1_box,
//   styles.highlights1_box_layout
//   )}>
//   <pre className={cn(styles.highlights)}>
//   {'Revenue'}
//   </pre>
//   </h5>
//   <div>

//   <RevenueComponent data = {revenueDetail} selectValue={selectTimeValue}/>
//   </div>
//   </div>
//   </div>
//   </div>
//   </div>
//   </>
//   );
//  }
